import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import { MessageService } from 'primeng/components/common/messageservice';
@Injectable()
export class BanneresService extends BaseService<any>{

  private static BANNER_RESOURCE: string = "/banneres";

  constructor(protected http: Http, protected messageService: MessageService) {
    super(http, messageService);
  }

  public saveBanner(banner: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_MULTIPART_FORM_DATA, true);
    let options = new RequestOptions({ headers: headers });
    let formData: FormData = new FormData();
    formData.append("posicion", "0");
    formData.append("fecha", "2018-01-01");
    if (banner.files != null) {
      for (let file of banner.files) {
        formData.append("imagen", file, file.name);
      }
    }
    if (banner.id == null) {
      this.post(BaseService.URL_BASE + BanneresService.BANNER_RESOURCE, formData, options, onSuccess);
    } else {
      formData.append("id", banner.id);
      this.put(BaseService.URL_BASE + BanneresService.BANNER_RESOURCE, formData, options, onSuccess);
    }
  }

  public deleteBanner(banner: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.delete(BaseService.URL_BASE + BanneresService.BANNER_RESOURCE + "/" + banner.id, options, onSuccess);
  }

  public getBanner(id: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    this.get(BaseService.URL_BASE + BanneresService.BANNER_RESOURCE + "/" + id, params, options, onSuccess);
  }

  public getBanneres(bannerFilter: any, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + BanneresService.BANNER_RESOURCE, params, options, onSuccess);
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/banneres.service.ts